import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import URL, { SERVER_URL } from '../../../constants/url';
import axiosApi from '../../../api/daonAxios';
import style from './Landing.module.css';
import logo from '../../../images/common/logo_landing_new.svg';
import globalIcon from '../../../images/common/i_global.svg';
import intelIcon from '../../../images/common/i_global_patient.svg';
import btnCircle from '../../../images/common/btn_circle_arrow.svg';
import NaverLogin from './sns/NaverLogin';
import KaKaoLogin from './sns/KakaoLogin';
import GoogleLogin from './sns/GoogleLogin';
import AppleLogin from './sns/AppleLogin';
import { getDpAuthRefeshTokenSimple, setDpAuthPushInfo } from '../../../assets/js/comm';
import ToastPopup from '../../../components/comm/ToastPopup';
import CODE from '../../../constants/code';
import PATH from '../../../constants/url';

//공지사항 팝업
import NoticePopup from '../../../components/comm/NoticePopup';


const Landing = () => {

    const navigate = useNavigate();

    const AFTCR_CRTFC_TKN = "AFTCR_CRTFC_TKN";

    // 리프레쉬 토큰
    const [userRequest2, setUserRequest2] = useState(
        { crtfcTknVal: localStorage.getItem(AFTCR_CRTFC_TKN) }
    );

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //공시사항 팝업 //
    const [showNotice, setShowNotice] = useState( false
        //() => !localStorage.getItem(AFTCR_CRTFC_TKN)  // 토큰 없을 때만 true
    );

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);

    /**
     * 푸시 기능부
     */
    const getNativAlrmPermission = () => {
        // 알람권한 및 파이어베이스 푸시토큰 발급 함수
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };

    /**
     * RN으로 푸시 큐 파기 신호 발송
     */
    const flushPendingPush = () => {
        setUserRequest2({});
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'WEB_READY_AUTH_FAIL' }));
        }
    };

    useEffect(() => {

        const handleNativeMessage = async (event) => {
            try {
                // 메시지 파싱
                const data = typeof event.data === 'string'
                    ? JSON.parse(event.data)
                    : event.data;

                if (!data.type) {
                    console.warn('⚠️ type 필드가 없는 메시지 받음:', data);
                    console.warn('⚠️ 이는 RN에서 type을 누락한 것으로 보입니다');
                    return; // type이 없으면 처리하지 않음
                }

                if (data.type === 'NOTIFICATION_PERMISSION_RESULT') {
                    // RN 에서 결과로 넘겨주는 알람 권한 및 파이어베이스 토큰
                    if (data.granted && data.token) {
                        console.log('✅ 권한 허용됨, 토큰 받음:', data.token);
                        try {
                            // SNS 로그인은 먼저 받은 후에 저장하고
                            // SNS 로그인 처리가 완료되면 dp 서버에 넣어주는 형식때문에
                            // 임시 저장 처리 로직 작성
                            sessionStorage.setItem('pushToken', data.token);

                        } catch (error) {
                            console.error('❌ 토큰 서버 전송 실패:', error);

                        }
                    } else if (data.granted && !data.token) {
                        console.log('⚠️ 권한은 허용됐지만 토큰이 없음 (재확인 메시지)');

                    } else {
                        console.log('❌ 권한 거부됨');
                    }

                } else if (data.type === 'NOTIFICATION_PERMISSION_STATUS') {
                    console.log('📋 권한 상태 확인 메시지 받음');
                    console.log('📋 granted:', data.granted);
                    console.log('📋 origin:', data.origin);

                    /* UI업데이트용 */
                }
            } catch (error) {
                console.error('메시지 처리 오류:', error);
            }
        };

        window.addEventListener('message', handleNativeMessage);
        return () => window.removeEventListener('message', handleNativeMessage);
    }, []);

    useEffect(() => {
        localStorage.removeItem('isOverseasMode'); // 랜딩페이지 localStorage 초기화

        getNativAlrmPermission();
        if (userRequest2.crtfcTknVal && isInitialRender.current) {
            handleFormSubmit2();
            isInitialRender.current = false;
        } else if (!userRequest2.crtfcTknVal && isInitialRender.current) {
            flushPendingPush();
            isInitialRender.current = false;
        }
    }, []);


    /**
     * 세션유지 자동로그인 : refresh 토큰 처리 >> 푸시토큰 옵션 추가
     * @returns {Element}
     */
    const handleFormSubmit2 = () => {

        getDpAuthRefeshTokenSimple(userRequest2.crtfcTknVal) // 간소화 버전 처리
            .then((data) => {
                //console.log( " ===========> handleFormSubmit2 / getDpAuthRefeshTokenSimple :: ", data );
                const { accessToken, refreshToken } = data;
                localStorage.setItem("jToken", accessToken);
                const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

                const userReq = {
                    crtfcTknVal: refreshToken
                }
                const requestOptions = {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
                axiosApi.post(requestCdssUrl, userReq, requestOptions)
                    .then((resp) => {
                        if (Number(resp.data.resultCode) === Number(CODE.RCV_SUCCESS)) {

                            const aftcrUser = resp.data.result.userInfo;

                            localStorage.setItem("jToken", accessToken);
                            localStorage.setItem(AFTCR_CRTFC_TKN, refreshToken);
                            sessionStorage.setItem("loginUser", JSON.stringify(aftcrUser));

                            if (aftcrUser.usrSeCd !== '17') {
                                if (aftcrUser.usrHsptlMap.length > 0) {
                                    const pushToken = sessionStorage.getItem('pushToken');
                                    // 푸시토큰 업데이트
                                    if(pushToken !== undefined && pushToken !== null && pushToken !== "" ) {
                                        if( pushToken !== aftcrUser.pushTknVal ) { // 푸시토큰 값이 변경된 경우에만 업데이트 처리..
                                            setDpAuthPushInfo(aftcrUser?.usrUid, pushToken)
                                                .then(res => {
                                                    if (res) {
                                                        // 피드백은 크게 필요없음..
                                                        console.log(" ===========> setDpAuthPushInfo  :: ", " >>> pushToken update complete <<< ");
                                                    }
                                                })
                                                .catch(err => {
                                                    console.log(" setDpAuthPushInfo error :: ", err);
                                                });
                                        }
                                    }
                                    // 정상케이스
                                    navigate(PATH.HOME_CARE_MAIN);
                                } else {
                                    // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결 페이지가 뜨도록 조정해야함.
                                    navigate(PATH.HOSPITAL_LINK);
                                }
                            } else {
                                //해외비대면인 경우
                                navigate(URL.CONTACTLESS_MAIN);
                            }
                        } else {
                            flushPendingPush();
                            setToastMessage("자동 로그인 업데이트에 실패하였습니다.\n다시 로그인을 시도해주세요.");
                            setToast(true);
                            localStorage.setItem("jToken", "");
                            localStorage.setItem(AFTCR_CRTFC_TKN, "");
                            sessionStorage.setItem("loginUser", JSON.stringify({}));

                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        flushPendingPush();
                        setToastMessage("인증정보 업데이트에 실패하였습니다.\n다시 로그인을 시도해주세요.");
                        setToast(true);
                        localStorage.setItem("jToken", "");
                        localStorage.setItem(AFTCR_CRTFC_TKN, "");
                        sessionStorage.setItem("loginUser", JSON.stringify({}));
                        //sessionStorage.setItem('loginUserMenu', JSON.stringify({}));

                    });
            })
            .catch(err => {
                console.log(err);
                flushPendingPush();
                setToastMessage('인증정보를 가져오지 못했습니다.\n다시 로그인을 시도해주세요.');
                setToast(true);
                localStorage.setItem("jToken", "");
                localStorage.setItem(AFTCR_CRTFC_TKN, "");
                sessionStorage.setItem("loginUser", JSON.stringify({}));
            });
    }

    //카카오 채널 이동
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }

    
    return (
        <>
            {/* 공지 팝업 */}
            {showNotice && (
                <NoticePopup
                    visible={showNotice}
                    onClose={() => {
                        sessionStorage.setItem('noticeClosed', 'true');
                        setShowNotice(false);
                    }}
                    title={"서버 점검으로 인해 일부 서비스 이용이\n일시적으로 제한됩니다."}
                    maintenanceTime="오후 6시 ~ 오후 8시 예정"
                    duration="약 2시간 소요"
                    description={"이용에 불편을 드려 죄송합니다."}
                    descriptionSub={"(영향 받는 서비스 : 병원케어, 환자정보 등)"}
                />
            )}

            { !userRequest2?.crtfcTknVal &&

            <div className='container' data-padding='none' data-bg-color="white">
                <div className='inner-wrap' data-pad="normal">

                    <div className={style['logo-box']}>
                        <h1>
                            <img src={logo} alt="" />
                        </h1>
                    </div>

                    <div className={style['bottom-box']}>
                        <div className={style['main-login-btns']}>
                            {/* <button data-login-btn="kao" onClick={kakaoLogin}>
                                <span>카카오로 시작하기</span>
                            </button>    */}

                            <button data-login-btn="normal" onClick={() => navigate(URL.LOGINMAIN)}>
                                <span>아이디로 로그인</span>
                            </button>
                        </div>
                        <div className={style['line']}>
                            <span>다른 방법으로 시작하기</span>
                        </div>
                        <div className={style['etc-login-btns']}>
                            <ul>
                                <li>
                                    <KaKaoLogin />
                                </li>
                                <li>
                                    {/* <button data-login="apple" onClick={() => alert("준비중입니다..")}></button> */}
                                    <AppleLogin />
                                </li>
                                <li>
                                    {/* <button data-login="naver" onClick={() => navigate(URL.IDENTITY)}></button> */}
                                    <NaverLogin />
                                </li>
                                <li>
                                    <GoogleLogin />
                                </li>
                            </ul>
                        </div>
                        <div className={style['inquiry-btn-box']}>
                            <button className={style['inquiry-btn']} onClick={() => handleOnJoinMeeting('https://pf.kakao.com/_xlvxeHn/chat')}>
                                <span>회원가입 및 사용 문의</span>
                            </button>
                        </div>

                        {/* <div className={style['notice-box']} onClick={() => navigate(URL.NONFACE_LOGIN_MAIN)}> */}
                            {/* <p>국제진료 비대면 상담</p> */}
                            {/* <p>
                                <img src={globalIcon} alt="국제진료 비대면 아이콘" />
                                Telemedicine Consultation for <br />
                                International Patients</p>
                            <span>Overseas residents who cannot verify</span>
                            <span>their identity in Korea</span>
                        </div> */}
                        <div className={style['intel-patients-box']} onClick={() => {
                            localStorage.setItem('isOverseasMode', 'true');
                            navigate(URL.NONFACE_LOGIN_MAIN);
                        }}>
                            <span>
                                <img src={intelIcon} alt="해외진료 아이콘" />
                            </span>
                            <strong>International Patients</strong>
                            <button className={style['intel-pati-btn']}>
                                <img src={btnCircle} alt="해외진료 바로가기" />
                            </button>
                        </div>
                    </div>

                    {toast && (
                        <ToastPopup
                            message={toastMessage}
                            setToast={setToast}
                            position="center"
                            opacity="90"
                        />
                    )}

                </div>
            </div>
            }
        </>
    )
}

export default Landing;
